import { Component, Injectable, Input, NgZone, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
// import { ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerConfig, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { DateService } from 'src/app/services/date.service';
import { facilityService } from 'src/app/services/facility.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter, NgbDateNativeAdapter, NgbDatepicker, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { BookFacilityComponent } from 'src/app/modal/book-facility/book-facility.component';
import { CancelFacilityBookingComponent } from 'src/app/modal/cancel-facility-booking/cancel-facility-booking.component';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  standalone: false,
  selector: 'app-view-blocked-facility',
  templateUrl: './view-blocked-facility.component.html',
  styleUrls: ['./view-blocked-facility.component.scss']
})
export class ViewBlockedFacilityComponent implements OnInit {
  @Input() list;
  toDate: Date;
  selectAll: boolean = false;
  selectedToDate: any;
  tDate: any;
  formattedSelectedToDate: any;
  companyList: any;
  multiSelectionCompanyName: any = [];
  selectedCompanyName: any;
  selctionlength: number;
  selectedId: any;
  page: any = 1;
  tempHistoryList: any = [];
  pageSize: number = 10;
  tempDate: any;
  totalCount: any;
  BookingStatus: any = [
    { statusText: 'Confirmed', statusValue: true },
    { statusText: 'Cancelled', statusValue: false },
  ];
  openOptionDrawer: boolean = false;
  BookingStatusText: any;
  BookStatusValue: any;
  FacilityBookedDetails: any;
  FacilityId: any;
  facilityName: string;
  tempTime: any;
  closeResult: string;
  disbursePoints: number = undefined;
  bookingId: any;
  multiSelectBookingId: any = [];
  singleBooking: boolean;
  tempFacilityDetail: any[] = [];
  meetingNav: { index: string; name: string; link: string }[];
  facilityAlreadyBlockDetails = [];
  BookingStatusTextTemp: any;

  //pagination
  // pageSize = 10;
  pageNo = 1;
  // totalCount = 0;
  displayCount = 0;
  totalCountList: number = 0;
  fromDate: any;
  selectedFromDate: any;
  formattedSelectedFromDate: any;
  fDate: any;

  constructor(
    private router: Router,
    public datepipe: DatePipe,
    private appStateSrv: AppStateProvider,
    private zone: NgZone,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private dateSrv: DateService,
    private apiSrvice: facilityService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private sideNavService: SidenavService
  ) {
    ngbDatepickerConfig.outsideDays = 'visible';
  }

  ngOnInit(): void {
    this.facilityName = localStorage.getItem('viewBooking');
    this.activatedRoute.queryParams.subscribe((res) => {
      this.FacilityId = res.FacilityId;
      const customUrl = `/facility/view-booking?FacilityId=${res.FacilityId}`
      const route = this.sideNavService.routingChunks({ name: 'Facility Booking', customUrl: customUrl });
      this.appStateSrv.setSideNavState(route);
    });

    const jsDate = new Date();
    this.BookingStatusText = this.BookingStatus[0].statusText;
    this.BookingStatusTextTemp = this.BookingStatus[0].statusText;
    this.BookStatusValue = this.BookingStatus[0].statusValue;

    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.selectedFromDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');

    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.formattedSelectedFromDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );

    let newToDate = new Date(this.selectedToDate);
    // Add 7 days to the date
    newToDate.setDate(newToDate.getDate() + 1);
    // Get the updated date in the format 'MM/DD/YYYY'
    this.selectedToDate = (newToDate.getMonth() + 1) + '/' + newToDate.getDate() + '/' + newToDate.getFullYear();

    // Convert 'updatedDate' string to a Date object
    let updatedDateObj = new Date(this.selectedToDate);

    // Format the Date object to a locale string
    let formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      updatedDateObj.getDate(),
      updatedDateObj.getMonth(),
      updatedDateObj.getFullYear()
    );

    // Now assign the formatted date to 'this.formattedSelectedToDate'
    this.formattedSelectedToDate = formattedSelectedToDate;


    this.getFaclittyDetails();
  }

  // getFaclittyDetails() {
  //   const body = {
  //     facilityId: this.FacilityId,
  //     status: this.BookStatusValue,
  //     startDate: this.selectedToDate,
  //   };
  //   this.apiSrvice.GetBookedFacilityList(body).subscribe((res) => {
  //     console.log('detail', res);
  //     this.FacilityBookedDetails = res;
  //   });
  // }

  compareDate(date) {
    return new Date(date) > new Date() ? true : false
  }

  setStatus(item) {
    console.log(item);
    this.BookingStatusText = item.statusText;
    this.BookingStatusTextTemp = item.statusText;
    this.BookStatusValue = item.statusValue;
    this.getFaclittyDetails();
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover, id) {
    this.singleBooking = false;
    this.disbursePoints = undefined

    console.log(id);
    if (id !== 0) {
      this.singleBooking = true;
      this.bookingId = id;
    }
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  formatDateToString(dateString) {
    const [month, day, year] = dateString.split('/'); // Split the date string into components

    // Ensure day and month have leading zeros if needed
    const formattedDay = day.padStart(2, '0');
    const formattedMonth = month.padStart(2, '0');

    return `${formattedMonth}/${formattedDay}/${year}`; // Format and concatenate components
  }

  public async updateSelectedToDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.toDate = jsDate;
    this.selectedToDate = this.formatDateToString(this.datepipe.transform(jsDate, 'MM/dd/yyyy'));
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    this.getFaclittyDetails();
  }

  public async updateSelectedFromDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.fromDate = jsDate;
    this.selectedFromDate = this.formatDateToString(this.datepipe.transform(jsDate, 'MM/dd/yyyy'));
    this.formattedSelectedFromDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );

    // let newToDate = new Date(this.selectedFromDate);
    // newToDate.setDate(newToDate.getDate() + 1);
    // this.selectedToDate = (newToDate.getMonth() + 1) + '/' + newToDate.getDate() + '/' + newToDate.getFullYear();
    // let updatedDateObj = new Date(this.selectedToDate);
    // let formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
    //   updatedDateObj.getDate(),
    //   updatedDateObj.getMonth(),
    //   updatedDateObj.getFullYear()
    // );
    // this.formattedSelectedToDate = formattedSelectedToDate;

    this.getFaclittyDetails();
  }

  // handlePageChange(event) {
  //   console.log(event);
  //   this.page = event;
  // }

  formatDate(date) {
    if (date == null) return;
    this.tempDate = date.split('T')[0].split('-');
    return this.dateSrv.convertDateToLocaleString(
      this.tempDate[2],
      this.tempDate[1] - 1,
      this.tempDate[0]
    );
  }

  formatTime(time) {
    if (time == null) return;
    this.tempTime = time.split('T')[1].split(':');
    if (this.tempTime[0] === '00' && this.tempTime[1] === '00') {
      return '12:00AM';
    } else if (this.tempTime[0] == 12) {
      return this.tempTime[0] + ':' + this.tempTime[1] + 'PM';
    } else {
      return this.tempTime[0] > 12
        ? this.tempTime[0] - 12 + ':' + this.tempTime[1] + 'PM'
        : this.tempTime[0] + ':' + this.tempTime[1] + 'AM';
    }
  }

  open(content) {
    console.log('open modal', this.bookingId);
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'modal-class',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  close(content) {
    // this.disbursePoints=0;
    this.modalService.dismissAll();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  disburse() {
    const data = {
      bookingId: this.bookingId,
      amount: this.disbursePoints,
    };
    console.log(data);
    this.apiSrvice.disburseDeposit(data).subscribe((res) => {
      console.log(res);
      if (res?.isValid == true) {
        this.getFaclittyDetails()
      }
      this.disbursePoints = undefined;
    });
  }

  cancelBooking(caledarId) {
    this.BookingStatusTextTemp = 'Confirmed';
    console.log("cancel", caledarId);
    this.apiSrvice.cancelBlockedFacility(caledarId).subscribe((res) => {
      console.log(res);
      // if (res?.isValid == true) {
      //   this.getFaclittyDetails()
      // }
      this.getFaclittyDetails();
      // location.reload();
    });
  }

  editBlocking(caledarId, startDateTime, endDateTime, purpose, remarks, bookingType, userId, facilityCalendarId) {

    localStorage.setItem('facilityCalendarId', caledarId);

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(BookFacilityComponent, modalOptions);
    modalRef.componentInstance.facilityId = this.FacilityId;
    modalRef.componentInstance.userId = localStorage.getItem('claAdminId');
    modalRef.componentInstance.facilityDayFromName = localStorage.getItem('facilityOperationFromDay');
    modalRef.componentInstance.facilityDayToName = localStorage.getItem('facilityOperationToDay');
    modalRef.componentInstance.facilityStartTime = localStorage.getItem('maintainenceStartTime');
    modalRef.componentInstance.facilityEndTime = localStorage.getItem('maintainenceEndTime');
    modalRef.componentInstance.maintainenceStartDate = localStorage.getItem('maintainenceStartDate');
    modalRef.componentInstance.maintainenceEndDate = localStorage.getItem('maintainenceEndDate');
    modalRef.componentInstance.isFacilityEdit = 'yes';
    modalRef.componentInstance.bookedStartDateTime = startDateTime;
    modalRef.componentInstance.bookedEndDateTime = endDateTime;
    modalRef.componentInstance.purpose = purpose;
    modalRef.componentInstance.remarks = remarks;
    modalRef.componentInstance.bookingTypeHourDaily = bookingType;
    modalRef.componentInstance.bookedByUserId = userId;
    modalRef.componentInstance.facilityCalendarId = facilityCalendarId;
  }

  formatDateForBlocking(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    else {
      this.tempDate = date.split('T')[1].split(':');
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM';
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type;

    }
  }

  navigateToDetail() {
    this.router.navigate(['/facility/detail'], {
      queryParams: {
        Facilityid: this.FacilityId,
        FacilityTypeId: localStorage.getItem("facilityTypeId"),
      },
    });
  }

  toggleSelectAllSelection(show) {
    this.multiSelectBookingId = [];
    if (this.selectAll) {
      this.tempFacilityDetail = this.FacilityBookedDetails.filter(el => new Date(el?.startDateTime) > new Date())
      console.log("select all", this.tempFacilityDetail)
      this.tempFacilityDetail.forEach((element) => {
        this.multiSelectBookingId.push(element.facilityCalendarId);
      });
    } else {
      this.multiSelectBookingId = [];
    }
    console.log('iddd', this.multiSelectBookingId);
    return this.multiSelectBookingId;
  }

  toggleSelection(show, id) {
    if (this.multiSelectBookingId.includes(id)) {
      this.multiSelectBookingId.splice(
        this.multiSelectBookingId.indexOf(id),
        1
      );
    } else {
      this.multiSelectBookingId.push(id);
    }

    this.selectAll =
      this.FacilityBookedDetails.length == this.multiSelectBookingId.length
        ? true
        : false;
    console.log('ifff', this.multiSelectBookingId);

    return this.multiSelectBookingId;
  }

  getFaclittyDetails() {
    console.log(this.BookingStatusTextTemp);
    if (this.BookingStatusTextTemp == 'Confirmed' || this.BookingStatusTextTemp == 'Confirm') {
      this.BookingStatusTextTemp = 'Confirm';
    } else {
      this.BookingStatusTextTemp = 'Cancel';
    }
    this.facilityAlreadyBlockDetails = [];
    this.facilityAlreadyBlockDetails.push({
      facilityId: this.FacilityId,
      getType: this.BookingStatusTextTemp,
      pageNo: this.pageNo,
      size: this.pageSize,
      fromDate: this.selectedFromDate,
      toDate: this.selectedToDate
    });
    this.apiSrvice
      .getAllFacilityBlockData(this.facilityAlreadyBlockDetails[0])
      .subscribe((res) => {
        this.FacilityBookedDetails = res?.list;
        this.totalCountList = res?.list.length;
      });
  }

  fetchPage(val) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  handlePageChange($event) {
    this.pageNo = $event;
    this.getFaclittyDetails();
  }

  cancelFacilityBooking(calendarId) {

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(CancelFacilityBookingComponent, modalOptions);
    modalRef.componentInstance.facilityId = calendarId;
  }
}

